module.exports = __webpack_public_path__ + "media/domenj/aecid-da19d82a.png";